import PropTypes from 'prop-types';
import Action from '../../Action';
import '../style.scss';

const PersonalHeader = ({ title, actions, mode }) => {
  return (
    <div className="personal-details-header">
      <div className="personal-details-title">{title}</div>
      <div className="personal-details-actions">
        {actions?.map((action, index) => (
          <Action
            key={index}
            icon={action.icon}
            handleClick={action.handleClickAction}
            txt={action.txt}
            isBold={mode && mode === action.name}
          ></Action>
        ))}
      </div>
    </div>
  );
};

export default PersonalHeader;

PersonalHeader.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.array,
  mode: PropTypes.string
};
